import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface ChecklistItem {
  path: string;
  label: string;
  criticalSelectors?: string[]; // elementos que devem existir
}

const CHECKLIST: ChecklistItem[] = [
  { path: '/dashboard', label: 'Dashboard', criticalSelectors: ['.small-box', '.card'] },
  { path: '/consultas', label: 'Lista Consultas', criticalSelectors: ['table', '.mobile-data-card'] },
  { path: '/pacientes', label: 'Lista Pacientes', criticalSelectors: ['table', '.mobile-data-card'] },
  { path: '/consultas/nova', label: 'Agendar Consulta', criticalSelectors: ['form', '.mobile-action-bar'] },
  { path: '/agenda', label: 'Agenda', criticalSelectors: ['.fc'] },
  { path: '/sophyteca', label: 'Sophyteca', criticalSelectors: ['.card'] },
  { path: '/todo-list', label: 'Todo List', criticalSelectors: ['.card'] },
];

interface ResultItem {
  path: string;
  ok: boolean;
  missing: string[];
}

export default function VisualChecklist() {
  const [results, setResults] = useState<ResultItem[]>([]);

  useEffect(() => {
    // Executa verificação simples após render
    const timer = setTimeout(() => {
      setResults(prev => {
        return CHECKLIST.map(item => {
          const missing: string[] = [];
          item.criticalSelectors?.forEach(sel => {
            if (!document.querySelector(sel)) missing.push(sel);
          });
          return { path: item.path, ok: missing.length === 0, missing };
        });
      });
    }, 400); // aguardar transições iniciais
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="card card-outline card-primary mt-3">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0"><i className="fas fa-check-square mr-1"></i>{' '}Checklist Visual (Mobile)</h5>
        <small className="text-muted">Verifique rapidamente presença de elementos chave</small>
      </div>
      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table table-sm mb-0">
            <thead className="thead-light">
              <tr>
                <th>Rota</th>
                <th>Status</th>
                <th>Faltando</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {CHECKLIST.map(item => {
                const res = results.find(r => r.path === item.path);
                return (
                  <tr key={item.path}>
                    <td>{item.label}</td>
                    <td>
                      {res ? (
                        res.ok ? (
                          <span className="badge badge-success">OK</span>
                        ) : (
                          <span className="badge badge-danger">Incompleto</span>
                        )
                      ) : (
                        <span className="badge badge-secondary">...</span>
                      )}
                    </td>
                    <td style={{ maxWidth: 200 }}>
                      {res && res.missing.length > 0 ? (
                        <small className="text-danger">{res.missing.join(', ')}</small>
                      ) : (
                        <small className="text-muted">-</small>
                      )}
                    </td>
                    <td>
                      <Link to={item.path} className="btn btn-sm btn-outline-primary">Ir</Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="p-2 border-top bg-light">
          <small className="text-muted">
            Esta verificação é heurística: abra a rota em nova aba mobile para validar layout real.
          </small>
        </div>
      </div>
    </div>
  );
}
